import React, { useState } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import { money } from "./shared";

const KEYS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

// Legacy "Add Item To Work Order" quantity popup with a 1–12 touch keypad + manual entry.
export const QtyKeypad = ({ item, onAdd, onClose }) => {
  const [qty, setQty] = useState("1");
  const n = Number(qty);
  const ok = n > 0;
  return createPortal(
    <div className="fixed inset-0 z-[140] bg-black/50 flex items-center justify-center p-4" onClick={onClose} data-testid="wo-qty-popup">
      <div className="w-full max-w-sm rounded-md overflow-hidden shadow-2xl border border-[#5b8ac4]" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between bg-[#123a63] text-white px-3 py-2">
          <span className="font-black text-sm">Add Item To Work Order</span>
          <button onClick={onClose} data-testid="wo-qty-close"><X className="h-4 w-4" /></button>
        </div>
        <div className="p-4 text-center" style={{ background: "linear-gradient(180deg,#eaf3fb,#bcd6ef)" }}>
          <p className="font-black text-lg underline leading-tight" data-testid="wo-qty-item">{item.name}</p>
          <p className="mt-2 text-[11px] italic text-slate-500">Amount</p>
          <p className="inline-block bg-white border border-slate-300 rounded px-4 py-1 font-black text-xl" data-testid="wo-qty-amount">{money(item.price)}</p>
          <p className="mt-3 font-bold text-slate-700">How many would you like?</p>
          <div className="grid grid-cols-4 gap-1.5 mt-2" data-testid="wo-qty-keypad">
            {KEYS.map((k) => (
              <button key={k} onClick={() => setQty(String(k))} data-testid={`wo-qty-key-${k}`}
                className={`rounded border py-3 font-black text-lg transition-colors ${String(k) === qty ? "bg-[#123a63] text-white border-[#123a63]" : "bg-white border-slate-300 hover:bg-sky-100"}`}>{k}</button>
            ))}
          </div>
          <p className="mt-3 text-[11px] italic text-slate-500">Quantity</p>
          <input type="number" min="0" step="any" value={qty} onChange={(e) => setQty(e.target.value)} data-testid="wo-qty-input"
            onKeyDown={(e) => { if (e.key === "Enter" && ok) onAdd(n); }}
            className="w-28 text-center rounded border border-slate-300 py-1.5 font-black text-xl" />
          <p className="mt-1 text-[12px] font-bold text-slate-600" data-testid="wo-qty-gross">Gross {money((n || 0) * (item.price || 0))}</p>
          <button disabled={!ok} onClick={() => onAdd(n)} data-testid="wo-qty-add"
            className="mt-3 w-full rounded-full bg-gradient-to-b from-[#5aa5e6] to-[#2a6cb5] text-white font-black py-2.5 shadow disabled:opacity-40 hover:brightness-110">Add To Work Order</button>
        </div>
      </div>
    </div>,
    document.body
  );
};
